module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.obj.view.w + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.view.id
    }
  }, [_c('div', {
    staticClass: "sms_shell"
  }, [_c('div', {
    staticClass: "title control"
  }, [_c('div', {
    staticClass: "smsTitle"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.add.sendSMS')))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        return _vm.deleteNode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "is-overlay overlay-for-not-admin"
  }), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal is-inline-block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.sms.gateway')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body is-inline-block"
  }, [_c('div', {
    staticClass: "field is-narrow"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.gateway),
      expression: "obj.data.gateway"
    }],
    staticClass: "smsGateway",
    attrs: {
      "name": "smsGateway"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.obj.data, "gateway", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.obj.availableSmsGateways), function(gateway) {
    return _c('option', {
      domProps: {
        "value": gateway
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.gateways[gateway]) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "field-body is-inline-block sender-field"
  }, [_c('div', {
    staticClass: "field-label is-normal is-inline-block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.sms.sender')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body is-inline-block"
  }, [_c('div', {
    staticClass: "field is-narrow"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.sender),
      expression: "obj.data.sender"
    }],
    staticClass: "input sender",
    domProps: {
      "value": (_vm.obj.data.sender)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "sender", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.text),
      expression: "obj.data.text"
    }],
    staticClass: "textarea smsText",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.sms.messageText'),
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.sms.messageText')
    },
    domProps: {
      "value": (_vm.obj.data.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "text", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-846ddb0c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/Sms.vue
// module id = 482
// module chunks = 42